function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M54.723 30.223L30.5 21 6.277 30.223",
  stroke: "#fff",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgArrowPullUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 47,
    viewBox: "0 0 61 47",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjEiIGhlaWdodD0iNDciIHZpZXdCb3g9IjAgMCA2MSA0NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNNTQuNzIyOSAzMC4yMjI5TDMwLjUgMjFMNi4yNzcxMSAzMC4yMjI5IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgArrowPullUp as ReactComponent };